module.exports = __webpack_public_path__ + "static/Minipixlogo-72949bdcb2c7eb6200c0048c2189a5a7.png";